const SH=window.BUNK_SHAPES;

/* ──────────────────────────────────────────────────────────────────────
   Products come from the Bunk Builder collection via Liquid, not from here.
   Each product carries four metafields: bunk.slot, bunk.print,
   bunk.repeat_in and bunk.reverse (plus bunk.personalise where relevant).
   ────────────────────────────────────────────────────────────────────── */
const TILE=window.BUNK_TILE, REV=Object.assign({},window.BUNK_REV),
      INCH=Object.assign({},window.BUNK_INCH), TRATIO=window.BUNK_TRATIO,
      POSTER=window.BUNK_POSTER;

const SLOTS={
  comforter:{label:'Comforter',   plural:'Comforters',        hint:'The centrepiece',            upi:6.41,pscale:1},
  backrest :{label:'Backrest',    plural:'Boyfriend pillows & bedrests',hint:'Sits against the headboard',upi:6.41,fixed:20},
  blanket  :{label:'Throw blanket',plural:'Throw blankets',   hint:'Folded at the foot',         upi:6.41,pscale:0.58},
  poster   :{label:'Poster',      plural:'Camp posters',      hint:'17 × 11 in, above the bed',  upi:6.41,art:1,pers2:'Camp name'},
  laundry  :{label:'Laundry bag', plural:'Mesh laundry bags', hint:'Hangs off the foot post',    upi:6.41,fixed:15},
  sockbag  :{label:'Sock bag',   plural:'Mesh sock bags',   hint:'For the drawer',             photo:1,max:3},   // Abbie, 2026-10-14: sock bags join the builder (photo slot, up to three, floor at the foot of the bed)
  mat      :{label:'Mat',         plural:'Mats',              hint:'For cold cabin floors',      upi:6.8, pscale:0.525},
  /* Abbie, 2026-09-10: sheets, a comfort step (egg crates, mattress pads) and fun
     pillows. None has a printed repeat, so sheets show as a solid colour and the
     other two as the product photo. The keys keep their first two letters unique,
     because share links abbreviate slots that way: 'co' is already the comforter,
     so comfort is 'plush'. */
  sheets   :{label:'Sheets',      plural:'Sheet sets',        hint:'Fitted to the mattress',     color:1,max:2},   // two sets: the first fits the mattress, the second is the folded top sheet
  plush    :{label:'Comfort',     plural:'Egg crates, mattress pads & pillows',hint:'A softer mattress',   photo:1,max:4},   // Abbie, 2026-09-16: "make it so they can pick all three" + the memory foam pillow
  funpillow:{label:'Fun pillow',  plural:'Fun pillows',       hint:'Tossed on the bed',          photo:1,max:4}
};
const ORDER_ALL=['comforter','sheets','plush','backrest','funpillow','blanket','poster','laundry','sockbag','mat'];

const FALLBACK=window.BUNK_CATALOGUE||{};
let RAW=JSON.parse(document.getElementById('bunk-products').textContent);
if(!RAW.length){                       // no collection set — run straight off the embedded catalogue
  RAW=Object.keys(FALLBACK).filter(h=>FALLBACK[h].vid).map(h=>{
    const f=FALLBACK[h];
    return {id:f.vid,handle:h,title:f.title,price:f.price,url:f.url,available:true,
            slot:f.slot,print:f.print,repeat:f.repeat||0,reverse:f.reverse||'',
            pers:f.pers?'yes':'',stretch:!!f.stretch,img:f.img||'',hex:f.hex||'',plush:f.plush||0,side:f.side||''};
  });
}
RAW.forEach(p=>{                       // metafields win; the embedded map fills the gaps
  const f=FALLBACK[p.handle]; if(!f) return;
  if(!p.slot)    p.slot=f.slot;
  if(!p.print)   p.print=f.print;
  if(!p.repeat)  p.repeat=f.repeat||0;
  if(!p.reverse) p.reverse=f.reverse||'';
  if(!p.pers && f.pers) p.pers='yes';
  if(!p.img)     p.img=f.img||'';
  if(!p.hex)     p.hex=f.hex||'';
  if(!p.plush)   p.plush=f.plush||0;
  if(!p.stretch && f.stretch) p.stretch=true;       // placed panels (Pastel Dreams, Terez, Go Your Own Way)
  if(!p.side)    p.side=f.side||'';
});
/* A product's own personalization fields (Abbie, 2026-09-16: blankets and laundry bags can be named).
   Rendered hidden by the section, keyed by variant id; they replace the old name box where both exist. */
const PZ_STORE=document.getElementById('bunk-pz-store'), PZ={};
if(PZ_STORE) PZ_STORE.querySelectorAll('[data-bunk-pz]').forEach(n=>PZ[n.dataset.bunkPz]=n);
const CAT={};
ORDER_ALL.forEach(s=>{ if(SLOTS[s]) CAT[s]=Object.assign({items:[]},SLOTS[s]); });
RAW.forEach(p=>{
  const s=p.slot; if(!s||!CAT[s]) return;
  if(CAT[s].color||CAT[s].photo){                      // no printed repeat: a solid colour or the product photo
    const hex=/^#[0-9a-f]{3,8}$/i.test(p.hex||'') ? p.hex : '';
    if(CAT[s].color ? !hex : !p.img) return;           // nothing to show, no swatch
    CAT[s].items.push({k:p.handle,h:p.handle,n:p.title,p:p.price,vid:p.id,url:p.url,img:p.img||'',hex,plush:+p.plush||0,
      side:p.side||'', so:p.available===false, cut:(window.BUNK_PILLOW_CUT||{})[p.handle]||null, sale:!!p.sale});
    return;
  }
  const k = s==='poster' ? p.print : p.print;          // posters key on their own artwork slug
  if(!k || (!TILE[k] && !POSTER[k])) return;           // no artwork, no swatch
  if(p.repeat) INCH[k]=parseFloat(p.repeat);
  if(p.reverse) REV[k]=p.reverse;
  CAT[s].items.push({k,h:p.handle,n:p.title,p:p.price,vid:p.id,url:p.url,
    r:!!p.reverse && s==='comforter', pers:!!p.pers,
    art:s==='poster'?1:0, stretch:!!p.stretch, fixed:p.fixed||0, side:p.side||'', so:p.available===false, sale:!!p.sale});
});
/* Curated pairings — which prints Bee Bee says look good together.
   Same-print matches are offered first; these fill in after. */
const PAIRS={
  blossoms:['watercolor','lovesprinkle','discocherry'],
  bluehearts:['bluecherry','sparklesdenim','watercolor'],
  lilachearts:['lovesmiles','splatstars','watercolor'],
  leopard:['splatstars','pasteldreams','lovesprinkle'],

  lovesmiles:['lilachearts','lovesprinkle','splatstars'],
  lovesprinkle:['blossoms','watercolor','discocherry'],
  watercolor:['bluehearts','lilachearts','blossoms'],
  splatstars:['leopard','pasteldreams','lilachearts'],
  bowspearls:['blossoms','lovesprinkle','watercolor'],
  baseball:['streetsports','scribble','goat'],
  gaming:['streetsports','scribble','sneaker'],
  girlcollage:['goyourownway','lovesmiles','tootsie'],
  discocherry:['blossoms','lovesprinkle','cherrycheck'],
  bluecherry:['bluehearts','watercolor','sparklesdenim'],
  sparklesdenim:['bluecherry','bluehearts','discocherry'],
  terez:['lovesprinkle','splatstars','blossoms'],
  cherrycheck:['discocherry','blossoms','lovesprinkle'],
  pasteldreams:['splatstars','leopard','lilachearts'],
  cosmic:['watercolor','splatstars','lilachearts'],
  tootsie:['lovesprinkle','discocherry','blossoms'],
  goyourownway:['lovesmiles','splatstars','grunge'],
  grunge:['scribble','streetsports','goat'],
  basketball:['streetsports','scribble','goat'],
  football:['streetsports','scribble','footballplyr'],
  footballplyr:['football','streetsports','scribble'],
  soccer:['streetsports','scribble','basketball'],
  sneaker:['streetsports','basketball','gaming'],
  streetsports:['basketball','football','soccer'],
  scribble:['basketball','football','streetsports'],
  gaming:['sneaker','streetsports','scribble'],
  goat:['basketball','streetsports','grunge'],
  loveyoulots:['lovesmiles','lovesprinkle','blossoms']
};

Object.values(CAT).forEach(c=>c.items.forEach(it=>{ const n=PZ[String(it.vid)]; if(n){ it.pz=n; it.pers=false; } }));
const ORDER=ORDER_ALL.filter(s=>CAT[s] && CAT[s].items.length);
/* Personalization helpers: what's still missing (without marking it red), the extra charge, and a short summary. */
const pzVal=f=>{ const t=f.dataset.type;
  if(t==='Checkbox') return [...f.querySelectorAll('input[type=checkbox]:checked')].map(i=>i.value).join(', ');
  if(t==='Swatches'||t==='Font tiles'){ const r=f.querySelector('input[type=radio]:checked'); return r?r.value:''; }
  const i=f.querySelector('[data-bbp-input]'); return i?String(i.value||'').trim():''; };
const pzMissing=it=>!!(it.pz && [...it.pz.querySelectorAll('[data-bbp-field][data-required]')]
  .some(f=>!f.hidden && f.dataset.type!=='Heading' && !pzVal(f)));
const pzExtra=it=>it.pz&&window.BBP ? BBP.extraPrice(it.pz)/100 : 0;   // add-on prices are in cents
const priceOf=it=>Math.round((it.p+pzExtra(it))*100)/100;
const pzNote=it=>{ if(!it.pz||!window.BBP) return '';
  const pr=BBP.properties(it.pz);
  return Object.keys(pr).filter(k=>k.charAt(0)!=='_' && !/^no\b/i.test(pr[k])).map(k=>pr[k]).join(' · '); };
const pzReset=()=>Object.values(PZ).forEach(n=>{
  n.querySelectorAll('input,select,textarea').forEach(el=>{
    if(el.type==='checkbox'||el.type==='radio') el.checked=el.defaultChecked;
    else if(el.tagName==='SELECT') [...el.options].forEach(o=>o.selected=o.defaultSelected);
    else if(el.type!=='file') el.value=el.defaultValue; else el.value='';
    el.dispatchEvent(new Event('change',{bubbles:true})); });
  if(window.BBP) n.querySelectorAll('[data-bbp]').forEach(r=>BBP.update(r)); });
ORDER.forEach(k=>CAT[k].items.forEach((it,i)=>it.id=k.slice(0,2)+i));
const find=(k,id)=>CAT[k].items.find(i=>i.id===id)||null;
const onStep=k=>ORDER[S.step]===k;     // the open step, by slot rather than position
/* Comfort takes every pick (up to 4, 2026-09-16; was 2) and fun pillows up to 4 (Abbie, 2026-09-10). Those
   slots hold an array of ids in S.pick; every other slot holds one id or null. */
const maxOf=k=>(CAT[k]&&CAT[k].max)||1;
const picks=k=>{ const v=S.pick[k]; return Array.isArray(v)?v:(v?[v]:[]); };
const picked=k=>picks(k).map(id=>find(k,id)).filter(Boolean);
/* Girl or boy (Abbie, 2026-09-16: "we need to adjust it for girls or boys - depending on what they
   are building", with a question at the top "in case the mom wants to build for her daughter but she
   clicked on it from the boys side"). Each side offers only the products on her list for that step, in
   her order (window.BUNK_SIDES in bunk-catalogue.js). A step that isn't on her lists (Comfort) shows
   everything on both sides. */
const SIDES=window.BUNK_SIDES||null;
const sideList=(k,side)=>SIDES&&SIDES[side]&&SIDES[side][k]||null;
const inSide=(k,it,side=S.side)=>{ const l=sideList(k,side); return !l||l.includes(it.h); };
function optionsFor(k){
  const l=sideList(k,S.side); if(!l) return CAT[k].items;
  return CAT[k].items.filter(i=>l.includes(i.h)).sort((a,b)=>l.indexOf(a.h)-l.indexOf(b.h));
}
function pruneSide(){                    // drop picks the chosen side doesn't offer
  let n=0;
  ORDER.forEach(k=>{ const was=picks(k), keep=was.filter(id=>{ const it=find(k,id); return it&&inSide(k,it); });
    n+=was.length-keep.length; if(keep.length!==was.length) S.pick[k]=maxOf(k)>1?keep:(keep[0]||null); });
  return n;
}
/* Girls call it a boyfriend pillow, boys a bedrest. */
function applySide(){
  if(CAT.backrest) Object.assign(CAT.backrest, S.side==='boys'
    ? {label:'Bedrest',plural:'Bedrests'} : {label:'Boyfriend pillow',plural:'Boyfriend pillows'});
  const w=document.querySelector('[data-bunk-builder]'); if(w) w.dataset.side=S.side;
  document.querySelectorAll('[data-bunk-side]').forEach(b=>{
    const on=b.dataset.bunkSide===S.side; b.setAttribute('aria-pressed',String(on)); b.classList.toggle('on',on); });
}
/* Sold out (Abbie, 2026-09-10: "write sold out on it so they can't choose it"). Stock comes
   live from Shopify; a saved or shared bunk loses any pick that has sold out since. */
function pruneSoldOut(){
  let n=0;
  ORDER.forEach(k=>{ const was=picks(k), keep=was.filter(id=>{ const it=find(k,id); return it&&!it.so; });
    n+=was.length-keep.length; if(keep.length!==was.length) S.pick[k]=maxOf(k)>1?keep:(keep[0]||null); });
  return n;
}

const S={step:0,pick:Object.fromEntries(ORDER.map(k=>[k,maxOf(k)>1?[]:null])),name:'',side:'girls',
         pers:Object.fromEntries(ORDER.map(k=>[k,{a:'',b:''}]))};
const $=s=>document.querySelector(s);

/* Links and saved bunks name products by handle, so they still open after products are added or
   removed (the short ids shift). Older links with ids still load. */
const byHandle=(k,h)=>CAT[k].items.find(i=>i.h===h)||find(k,h);
const bunkQuery=()=>{
  const q=['s='+(S.side==='boys'?'b':'g')];
  ORDER.filter(k=>picks(k).length).forEach(k=>q.push(k[0]+k[1]+'='+picks(k).map(id=>encodeURIComponent(find(k,id).h)).join(',')));
  if(S.name)q.push('n='+encodeURIComponent(S.name));
  ORDER.forEach(k=>{const v=S.pers[k];
    if(v.a)q.push(k[0]+k[1]+'a='+encodeURIComponent(v.a));
    if(v.b)q.push(k[0]+k[1]+'b='+encodeURIComponent(v.b));});
  return q.join('&');
};
/* Abbie, 2026-09-22: "When you click into build my bunk, the girls choices show from the previous build. We need to
   just make sure this doesn't get tripped up." There used to be one saved draft with the side stored inside it, and
   loading it dragged that side along — so a girl's bunk reappeared on the boys side. It is now one draft per side
   ({girls:{...},boys:{...}}); the side always comes from the site (or her Girl/Boy question), never from the draft.
   An older single draft is filed under the side it was built for, so nobody loses a bunk in progress. */
function readDrafts(){
  try{const d=JSON.parse(localStorage.getItem('bunk4')||'null');
    if(!d||typeof d!=='object') return {};
    if(d.p) return d.s==='boys'?{boys:d}:{girls:d};
    return d;}catch(e){ return {}; }
}
function save(){
  const has=ORDER.some(k=>picks(k).length)||S.name;
  try{history.replaceState(null,'',has?'#'+bunkQuery():location.pathname)}catch(e){}
  try{const store=readDrafts(); store[S.side]={p:S.pick,n:S.name,e:S.pers,s:S.side};
      localStorage.setItem('bunk4',JSON.stringify(store));}catch(e){}
}
function load(){
  const aud=document.documentElement.dataset.bbdAudience;   // the side of the site they came from
  if(aud==='girls'||aud==='boys') S.side=aud;
  const hash=location.hash.slice(1);
  if(hash){const q=new URLSearchParams(hash);
    ORDER.forEach(k=>{const v=q.get(k[0]+k[1]); if(!v) return;
      const ids=v.split(/[.,]/).map(x=>byHandle(k,x)).filter(Boolean).map(i=>i.id).slice(0,maxOf(k));
      if(ids.length) S.pick[k]=maxOf(k)>1?ids:ids[0];});
    if(q.get('n'))S.name=q.get('n').slice(0,12);
    ORDER.forEach(k=>{['a','b'].forEach(f=>{const v=q.get(k[0]+k[1]+f);
      if(v)S.pers[k][f]=v.slice(0,18)});});
    if(ORDER.some(k=>picks(k).length)){
      const s=q.get('s'); if(s==='b'||s==='g') S.side=s==='b'?'boys':'girls';
      else { const c=picked('comforter')[0]; if(c&&(c.side==='boys'||c.side==='girls')) S.side=c.side; }
      return; }}
  try{const d=readDrafts()[S.side];          // only this side's draft — see readDrafts()
    if(d){ORDER.forEach(k=>{const v=d.p&&d.p[k];
        if(v){const ids=(Array.isArray(v)?v:[v]).filter(id=>find(k,id)).slice(0,maxOf(k));
          if(ids.length) S.pick[k]=maxOf(k)>1?ids:ids[0];}
        if(d.e&&d.e[k])S.pers[k]=d.e[k]});
      S.name=(d.n||'').slice(0,12);}}catch(e){}
}

(function texture(){
  let w='';
  for(let i=0,y=0;y<626;i++,y+=54){
    w+=`<rect y="${y}" width="1000" height="54" fill="var(--wall-${(i%3)+1})" opacity="${i%2?.9:1}"/>`;
    w+=`<rect y="${y+52}" width="1000" height="2.5" fill="var(--wall-line)" opacity=".55"/>`}
  $('#planks').innerHTML=w;
  let b='';
  for(let i=0,y=636;y<760;i++,y+=32){
    b+=`<rect y="${y}" width="1000" height="32" fill="var(--floor-${(i%2)+1})"/>`;
    b+=`<rect y="${y+30}" width="1000" height="2" fill="var(--floor-line)" opacity=".5"/>`}
  $('#boards').innerHTML=b;
})();

let uid=0;
/* Abbie, 2026-09-17: "change the bows pattern on the comforter - it should face the long way down the bed".
   Comforter prints turn a quarter left (her 2026-09-10 call); these ones stay as drawn. */
const NOTURN=new Set(['bowspearls']);
function fill(defs,it,cat){
  /* cat.fixed pins an absolute repeat for that product; otherwise the comforter
     repeat is scaled by cat.pscale.
     Comforter prints turn a quarter to the left. Abbie, 2026-09-10: "for the
     comforters, the patterns all need to turn 90 degrees to the left ... only for
     the comforters though". A tiled print rotates its tile; a placed panel is
     drawn turned inside the comforter's box, because rotating a box-relative
     pattern would stretch it. */
  const id='f'+(++uid), turn=cat===CAT.comforter&&!NOTURN.has(it.k),
        inches = it.fixed || cat.fixed || (INCH[it.k]||30)*(cat.pscale||1),
        s = inches*cat.upi, sh = s*(TRATIO[it.k]||1);
  if(it.stretch && turn){
    const B=COMF_BOX, cx=B.w/2, cy=B.h/2;
    defs.push(`<pattern id="${id}" patternUnits="userSpaceOnUse" x="${B.x}" y="${B.y}" width="${B.w}" height="${B.h}">
       <image href="${TILE[it.k]}" x="${cx-B.h/2}" y="${cy-B.w/2}" width="${B.h}" height="${B.w}"
         preserveAspectRatio="xMidYMid slice" transform="rotate(-90 ${cx} ${cy})"/></pattern>`);
    return `url(#${id})`;
  }
  defs.push(it.stretch
    ? `<pattern id="${id}" patternUnits="objectBoundingBox" patternContentUnits="objectBoundingBox" width="1" height="1">
         <image href="${TILE[it.k]}" width="1" height="1" preserveAspectRatio="xMidYMid slice"/></pattern>`
    : `<pattern id="${id}" patternUnits="userSpaceOnUse" width="${s}" height="${sh}"${turn?' patternTransform="rotate(-90)"':''}>
         <image href="${TILE[it.k]}" width="${s}" height="${sh}"/></pattern>`);
  return `url(#${id})`;
}
const GHOST=(paths,label,lx,ly)=>
  paths.map(d=>`<path d="${d}" fill="none" stroke="var(--ghost)" stroke-width="3" stroke-dasharray="11 9"
     opacity=".62" stroke-linejoin="round"/>`).join('')+
  `<text x="${lx}" y="${ly}" text-anchor="middle" fill="var(--ghost)" opacity=".85"
     font-family="Bricolage Grotesque, sans-serif" font-size="20" font-weight="700" letter-spacing=".04em">${label}</text>`;

const D_COMF='M150,392 C 280,366 470,364 706,388 C 714,432 712,486 704,524 C 640,538 556,522 468,530 C 382,538 282,520 200,532 C 176,535 160,528 150,520 C 144,472 144,432 150,392 Z';
const COMF_BOX={x:144,y:360,w:574,h:180};   /* the comforter's bounding box, for placed panels */
const D_CUFF='M150,390 C 244,368 344,370 424,386 L 414,440 C 332,422 234,424 154,444 Z';
const D_MAT='M283,639 C 358,633 442,633 517,639 C 532,672 542,705 553,735 C 445,743 325,743 247,735 C 259,705 270,672 283,639 Z';  /* drawn 1.5x oversize on purpose */
const POS={x:373.5,y:172,w:109,h:70.5};  /* 17 x 11 in landscape, centred over the bed */
/* A fun pillow: a puffy square tossed in front of the backrest's right arm. */
const FUN={cx:430,cy:362};
const D_FUN='M380,324 C 404,315 456,315 480,324 C 488,346 488,378 480,400 C 456,409 404,409 380,400 C 372,378 372,346 380,324 Z';
/* Where up to four fun pillows sit: bottom-centre on the bed, and a slight tilt. */
const FUN_SPOTS=[{cx:432,by:404,rot:-6},{cx:548,by:400,rot:5},{cx:318,by:406,rot:-3},{cx:650,by:398,rot:7}];
/* ── Angled bed (trial) ────────────────────────────────────────────────────
   Abbie, 2026-09-10: "try angling just the bed and comforter first". The bed,
   mattress and comforter are drawn at a three-quarter angle: head against the
   wall on the left, foot coming towards you on the right. What sits on the bed
   (backrest, fun pillows, throw, name tag) is moved onto it. The poster keeps
   its place, the laundry bag hangs from a wall peg and the mat moves to open
   floor. Off by default: add ?bed=angled to the page address, or set the
   section's "Bed view" to Angled. */
const ANGLED = (new URLSearchParams(location.search).get('bed')
  || ((document.querySelector('[data-bunk-builder]')||{}).dataset||{}).bedView || 'straight') === 'angled';
/* floor point (u along the bed, v across it, z up) to scene coordinates */
/* H is the mattress top above the floor. Abbie, 2026-09-10: "the bed needs to be not so low to the ground" (was 114). */
const AB={ox:175,oy:642,ux:.84,uy:.165,vx:.60,vy:-.40,L:510,W:250,H:165,T:34};
const PA=(u,v,z)=>[AB.ox+u*AB.ux+v*AB.vx, AB.oy+u*AB.uy+v*AB.vy-z];
const polyA=(...pts)=>'M'+pts.map(q=>q[0].toFixed(1)+','+q[1].toFixed(1)).join(' L')+' Z';
const affA=(o,a,b)=>`matrix(${a[0]} ${a[1]} ${b[0]} ${b[1]} ${o[0].toFixed(1)} ${o[1].toFixed(1)})`;
const TOP_UV=[[AB.ux,AB.uy],[AB.vx,AB.vy]], SIDE_UZ=[[AB.ux,AB.uy],[0,1]], FOOT_VZ=[[AB.vx,AB.vy],[0,1]];
const lineA=(...pts)=>'M'+pts.map(q=>q[0].toFixed(1)+','+q[1].toFixed(1)).join(' L');
/* A fixed wobble for soft edges. The same on every redraw, so the bed doesn't twitch as you pick. */
const wob=(t,a=1,ph=0)=>a*(Math.sin(t/31+ph)*5+Math.sin(t/11+ph*2)*2.2);

/* A print laid onto one face of the angled bed. Same rules as fill(): tiled prints
   repeat at their true size (scaled up a little, since the face is foreshortened),
   placed panels spread over the face, and comforter prints turn a quarter left. */
function fillFace(defs,it,cat,xf,bw,bh){
  const id='f'+(++uid), turn=cat===CAT.comforter&&!NOTURN.has(it.k);
  if(it.stretch){
    const img = turn
      ? `<image href="${TILE[it.k]}" x="${bw/2-bh/2}" y="${bh/2-bw/2}" width="${bh}" height="${bw}" preserveAspectRatio="xMidYMid slice" transform="rotate(-90 ${bw/2} ${bh/2})"/>`
      : `<image href="${TILE[it.k]}" width="${bw}" height="${bh}" preserveAspectRatio="xMidYMid slice"/>`;
    defs.push(`<pattern id="${id}" patternUnits="userSpaceOnUse" width="${bw}" height="${bh}" patternTransform="${xf}">${img}</pattern>`);
  } else {
    const inches = it.fixed || cat.fixed || (INCH[it.k]||30)*(cat.pscale||1), s=inches*cat.upi*1.4, sh=s*(TRATIO[it.k]||1);
    defs.push(`<pattern id="${id}" patternUnits="userSpaceOnUse" width="${s}" height="${sh}" patternTransform="${xf}${turn?' rotate(-90)':''}">
       <image href="${TILE[it.k]}" width="${s}" height="${sh}"/></pattern>`);
  }
  return `url(#${id})`;
}

function drawAngled(defs,{c,p,bl,lb,sh,sheetTop,pls,fps,lift}){
  const straight=$('#bedStraight'); if(straight) straight.style.display='none';
  ['comfL','thrL','sleepL','pillL','funL'].forEach(id=>{ const el=$('#'+id); if(el) el.removeAttribute('transform'); });
  $('#postL').setAttribute('transform',`translate(560 ${POS.y+POS.h/2+35}) scale(1.35) translate(${-POS.x-POS.w/2} ${-POS.y-POS.h/2})`);
  const L=AB.L, W=AB.W, T=AB.T, H=AB.H+lift, R=H-T, Hc=H+5, top=c?Hc:H;
  const wood='var(--frame)', dark='var(--frame-dark)';
  const leg=(u,v,h,w=13)=>`<path d="${polyA(PA(u,v,h),PA(u+w,v,h),PA(u+w,v,0),PA(u,v,0))}" fill="${wood}"/>`+
                         `<path d="${polyA(PA(u+w,v,h),PA(u+w,v+w,h),PA(u+w,v+w,0),PA(u+w,v,0))}" fill="${dark}"/>`;
  /* tall head posts with a cap, like a bunk; the name tag hangs from the near one */
  const POST_H=H+125;   // tall enough that the name tag hangs clear above the backrest
  const post=(u,v,w=20)=>leg(u,v,POST_H,w)+
    `<path d="${polyA(PA(u-4,v-4,POST_H),PA(u+w+4,v-4,POST_H),PA(u+w+4,v+w+4,POST_H),PA(u-4,v+w+4,POST_H))}" fill="var(--frame-light)"/>`;
  /* frame and mattress */
  const [sx,sy]=PA(L/2,W/2,0);
  let o=`<ellipse cx="${sx.toFixed(0)}" cy="${(sy+8).toFixed(0)}" rx="345" ry="48" fill="var(--shadow)"/>`;
  o+=leg(L-16,W-16,H+38,16)+post(0,W-20);
  /* Rails connect the head posts and give the pillows a visible support. */
  [H+38,H+84].forEach(z=>{
    o+=`<path d="${polyA(PA(5,0,z),PA(5,W,z),PA(5,W,z-27),PA(5,0,z-27))}" fill="var(--frame)"/>
      <path d="${lineA(PA(5,0,z),PA(5,W,z))}" fill="none" stroke="var(--frame-light)" stroke-width="3"/>`;
  });
  o+=`<path d="${polyA(PA(0,0,R),PA(L,0,R),PA(L,0,R-22),PA(0,0,R-22))}" fill="${wood}"/>`;
  o+=`<path d="${polyA(PA(L,0,R),PA(L,W,R),PA(L,W,R-22),PA(L,0,R-22))}" fill="${dark}"/>`;
  const mfill=sh?sh.hex:'var(--mattress)';
  const mTop=polyA(PA(0,0,H),PA(0,W,H),PA(L,W,H),PA(L,0,H)), mSide=polyA(PA(0,0,H),PA(L,0,H),PA(L,0,R),PA(0,0,R)), mFoot=polyA(PA(L,0,H),PA(L,W,H),PA(L,W,R),PA(L,0,R));
  o+=`<path d="${mTop}" fill="${mfill}"/><path d="${mSide}" fill="${mfill}"/><path d="${mSide}" fill="rgba(0,0,0,.08)"/>`;
  o+=`<path d="${mFoot}" fill="${mfill}"/><path d="${mFoot}" fill="rgba(0,0,0,.16)"/>`;
  if(pls.length) o+=`<path d="${mTop}" fill="rgba(255,255,255,.22)"/><path d="${mSide}" fill="url(#lightG)" opacity=".2"/>`;
  o+=`<path d="${mTop}" fill="none" stroke="rgba(0,0,0,.12)" stroke-width="1.5"/>`;
  o+=leg(L-16,0,R,16)+post(0,0);
  if(!sh && onStep('sheets')) o+=GHOST([mTop],'Sheets',...PA(L*.55,W/2,H));
  if(!pls.length && onStep('plush')) o+=GHOST([polyA(PA(0,0,H+16),PA(0,W,H+16),PA(L,W,H+16),PA(L,0,H+16))],'Comfort',...PA(L*.55,W/2,H+30));
  $('#mattL').innerHTML=o;

  /* comforter. Abbie, 2026-09-10: "it feels too perfect now - it was like a messier bed before".
     Drawn soft, like the straight-on bed: it puffs up a little, hangs well over the side
     and foot with wavy hems that droop at the corner, and has a rumpled fold at the head
     and a few creases. Edges are sampled points, so neighbouring faces share them exactly. */
  const cu=70, hang=66, sideHang=75, N=18;
  const span=(a,b,f)=>Array.from({length:N+1},(_,i)=>f(a+(b-a)*i/N,i/N));
  const puff=t=>Math.sin(Math.PI*t), P3=pts=>pts.map(q=>PA(...q));
  const corner=[L+14,-16,Hc-sideHang];                                               // the foot corner droops
  const nearTop=span(cu,L+6,(u,t)=>[u,-6-4*puff(t),Hc+3*puff(t)]);                   // head → foot
  const footTop=span(-6,W+6,(v,t)=>[L+6+4*puff(t),v,Hc+3*puff(t)]);                  // near → far
  const farTop=span(L+6,cu,u=>[u,W+6,Hc]);                                            // foot → head
  const fold=span(W+6,-6,v=>[cu+wob(v,.7,1),v,Hc+2]);                                 // far → near, the rumpled head edge
  const sideHem=span(L+14,cu,u=>[u,-16,Hc-sideHang]);  // foot → head, shorter at the head
  const footHem=span(W+6,-6,(v,t)=>[L+16+2*puff(t),v,Hc-hang+wob(v,1.3,2)-20*Math.exp(-Math.pow((1-t)/.16,2))]); // far → near
  const cTop=P3([...nearTop,...footTop.slice(1),...farTop.slice(1),...fold.slice(1,-1)]);
  const cSide=P3([...nearTop,corner,...sideHem.slice(1)]), cFoot=P3([...footTop,...footHem.slice(0,-1),corner]);
  if(c){
    const fTop=fillFace(defs,c,CAT.comforter,affA(PA(cu,-6,Hc),...TOP_UV),L+6-cu,W+12);
    const fSide=fillFace(defs,c,CAT.comforter,affA(PA(cu,-6,Hc),...SIDE_UZ),L+6-cu,sideHang+4);
    const fFoot=fillFace(defs,c,CAT.comforter,affA(PA(L+6,-6,Hc),...FOOT_VZ),W+12,hang+24);
    let q=`<path d="${polyA(...cSide)}" fill="${fSide}"/><path d="${polyA(...cSide)}" fill="rgba(0,0,0,.12)"/>`;
    q+=`<path d="${polyA(...cFoot)}" fill="${fFoot}"/><path d="${polyA(...cFoot)}" fill="rgba(0,0,0,.24)"/>`;
    /* soft folds hanging down the side and the foot */
    const drape=(a,b)=>`<path d="${lineA(a,b)}" fill="none" stroke="rgba(0,0,0,.06)" stroke-width="14" stroke-linecap="round"/>`;
    q+=[cu+90,cu+210,cu+330].map((u,i)=>drape(PA(u,-8,Hc-6),PA(u+(i%2?8:-8),-16,Hc-sideHang+14))).join('');
    q+=[W*.3,W*.72].map(v=>drape(PA(L+8,v,Hc-6),PA(L+16,v+6,Hc-hang+14))).join('');
    q+=`<path d="${polyA(...cTop)}" fill="${fTop}"/><path d="${polyA(...cTop)}" fill="url(#lightG)" opacity=".2"/>`;
    /* a few creases across the top */
    const crease=(a,m,b)=>{ const [p1,p2,p3]=[a,m,b].map(x=>PA(x[0],x[1],Hc+3));
      return `M${p1[0].toFixed(1)},${p1[1].toFixed(1)} Q${p2[0].toFixed(1)},${p2[1].toFixed(1)} ${p3[0].toFixed(1)},${p3[1].toFixed(1)}`; };
    q+=[crease([cu+70,W*.12],[cu+100,W*.36],[cu+125,W*.62]), crease([cu+190,W*.55],[cu+240,W*.46],[cu+300,W*.7]),
        crease([L-125,W*.18],[L-85,W*.3],[L-40,W*.16]), crease([cu+135,W*.86],[cu+175,W*.76],[cu+220,W*.92])]
      .map(d=>`<path d="${d}" fill="none" stroke="rgba(0,0,0,.07)" stroke-width="5" stroke-linecap="round"/>`+
               `<path d="${d}" fill="none" stroke="rgba(255,255,255,.16)" stroke-width="2.5" stroke-linecap="round" transform="translate(0 -3)"/>`).join('');
    if(c.r){   /* the reversible side, folded back at the head */
      const e1=span(-6,W+6,v=>[cu+wob(v,.7,1),v,Hc+4]), e2=span(W+6,-6,v=>[cu+60+wob(v,.9,2.5),v,Hc+4]);
      const back=c.rk?fillFace(defs,{k:c.rk},CAT.comforter,affA(PA(cu,-6,Hc+4),...TOP_UV),66,W+12):(REV[c.k]||'#B9C4C2');
      const cuff=polyA(...P3([...e1,...e2]));
      q+=`<path d="${cuff}" fill="${back}"/><path d="${cuff}" fill="rgba(255,255,255,.18)"/>`;
      q+=`<path d="${lineA(...P3(e2))}" fill="none" stroke="rgba(0,0,0,.2)" stroke-width="3" stroke-linecap="round"/>`;
    }
    if(sh){   /* the top sheet folded back over the comforter at the head */
      const band=polyA(...P3([...span(-6,W+6,v=>[cu-4+wob(v,.7,1),v,Hc+5]),...span(W+6,-6,v=>[cu+14+wob(v,.7,1),v,Hc+5])]));
      q+=`<path d="${band}" fill="${sheetTop.hex}"/><path d="${band}" fill="none" stroke="rgba(0,0,0,.18)" stroke-width="1.5"/>`;
    }
    q+=[cTop,cSide,cFoot].map(f=>`<path d="${polyA(...f)}" fill="none" stroke="rgba(0,0,0,.2)" stroke-width="2" stroke-linejoin="round"/>`).join('');
    $('#comfL').innerHTML=q;
  } else $('#comfL').innerHTML = onStep('comforter') ? GHOST([polyA(...cTop),polyA(...cSide),polyA(...cFoot)],'Comforter',...PA(L*.62,W/2,Hc)) : '';

  /* throw blanket tossed near the foot: a little crooked, with a soft hem */
  const b0=L-135,b1=L+12,bz=top+7;
  const bt=P3([[b0,-10,bz],[b0-18,W+8,bz],[b1,W+8,bz],[b1,-10,bz]]);
  const bs=P3([[b0,-10,bz],[b1,-10,bz],...span(b1,b0,u=>[u,-14,bz-38+wob(u,.8,3)])]);
  const bf=P3([[b1,-10,bz],[b1,W+8,bz],...span(W+8,-10,v=>[b1+5,v,bz-88+wob(v,.7,2)])]);
  if(bl){
    const ff=fillFace(defs,bl,CAT.blanket,affA(PA(b1,-10,bz),...FOOT_VZ),W+18,96);
    const ft=fillFace(defs,bl,CAT.blanket,affA(PA(b0,-10,bz),...TOP_UV),b1-b0,W+18);
    const fs=fillFace(defs,bl,CAT.blanket,affA(PA(b0,-10,bz),...SIDE_UZ),b1-b0,44);
    $('#thrL').innerHTML=`<path d="${polyA(...bs)}" fill="${fs}"/><path d="${polyA(...bs)}" fill="rgba(0,0,0,.14)"/>`+
      `<path d="${polyA(...bf)}" fill="${ff}"/><path d="${polyA(...bf)}" fill="rgba(0,0,0,.16)"/><path d="${polyA(...bt)}" fill="${ft}"/>`+
      [bt,bs,bf].map(f=>`<path d="${polyA(...f)}" fill="none" stroke="rgba(0,0,0,.22)" stroke-width="2" stroke-linejoin="round"/>`).join('');
  } else $('#thrL').innerHTML = onStep('blanket') ? GHOST([polyA(...bt),polyA(...bs)],'Throw',...PA((b0+b1)/2,W/2,bz)) : '';

  /* backrest: the straight-on drawing, stood at the head of the angled bed */
  const pill=$('#pillL');
  if(pill.innerHTML){ const [hx,hy]=PA(40,W*.66,top); pill.innerHTML=`<g transform="translate(${hx.toFixed(1)} ${hy.toFixed(1)}) scale(1.16) translate(${-SH.cx} ${-SH.bot})">${pill.innerHTML}</g>`; }

  /* the sleeping pillow: the straight-on drawing, laid at the head of the angled bed behind the backrest */
  const slp=$('#sleepL');
  if(slp.innerHTML){
    const pillowCase=sheetTop?sheetTop.hex:'#F8F6F1';
    slp.innerHTML=`<g transform="${affA(PA(8,8,top+16),[AB.vx,AB.vy],[AB.ux,AB.uy])}"><path d="M12,14 Q4,0 23,8 Q80,-10 139,8 Q159,0 151,18 Q165,67 151,117 Q160,137 138,128 Q80,139 22,128 Q1,137 10,117 Q-1,68 12,14 Z" fill="${pillowCase}" stroke="rgba(0,0,0,.22)" stroke-width="2" transform="translate(15.84 20.16)"/><path d="M12,14 Q4,0 23,8 Q80,-1 139,8 Q159,0 151,18 Q165,67 151,117 Q160,137 138,128 Q80,139 22,128 Q1,137 10,117 Q-1,68 12,14 Z" fill="${pillowCase}" stroke="rgba(0,0,0,.25)" stroke-width="2.5"/><path d="M22,23 Q80,9 137,23 Q147,65 136,108 Q80,122 23,109 Q12,68 22,23 Z" fill="rgba(255,255,255,.34)"/><path d="M129,8 Q143,67 129,130" fill="none" stroke="rgba(0,0,0,.19)" stroke-width="2.5"/><path d="M20,120 Q78,136 137,121" fill="none" stroke="rgba(0,0,0,.09)" stroke-width="6" stroke-linecap="round"/></g>`;
    $('#funL').parentNode.insertBefore(slp,$('#funL'));
  }

  /* fun pillows along the head of the bed; farther ones drawn first */
  if(fps.length){
    const spots=[{u:115,v:W*.64,rot:-4},{u:145,v:W*.28,rot:5},{u:182,v:W*.80,rot:-7},{u:200,v:W*.20,rot:6}]
      .slice(0,fps.length).map((s,i)=>Object.assign({},s,{it:fps[i],pt:PA(s.u,s.v,top+2)})).sort((a,b)=>a.pt[1]-b.pt[1]);
    $('#funL').innerHTML=spots.map(({it,pt,rot},i)=>{
      const cut=it.cut, mini=/\bmini\b/i.test(it.n), h=mini?58:86, w=cut?Math.min(150,h*cut.w/cut.h):h*1.2, x=pt[0]-w/2, y=pt[1]-h;
      const art=cut
        ? `<image href="${cut.src}" x="${x}" y="${y}" width="${w}" height="${h}" preserveAspectRatio="xMidYMax meet"/>`
        : `<clipPath id="fpa${i}"><rect x="${x}" y="${y}" width="${w}" height="${h}" rx="14"/></clipPath><image href="${it.img}" x="${x}" y="${y}" width="${w}" height="${h}" preserveAspectRatio="xMidYMid slice" clip-path="url(#fpa${i})"/>`;
      return `<g transform="rotate(${rot} ${pt[0]} ${pt[1]})"><ellipse cx="${pt[0]}" cy="${pt[1]+1}" rx="${w*.4}" ry="5" fill="rgba(0,0,0,.2)"/>${art}</g>`;
    }).join('');
  } else { const f=$('#funL'); if(f.innerHTML){ const [fx,fy]=PA(70,W*.5,top); f.innerHTML=`<g transform="translate(${(fx-FUN.cx).toFixed(1)} ${(fy-FUN.cy-40).toFixed(1)})">${f.innerHTML}</g>`; } }

  /* name tag hangs from the head post; laundry bag from a wall peg; mat on open floor */
  const tag=$('#tagL');
  if(tag.innerHTML){ const [tx,ty]=PA(10,0,POST_H); tag.innerHTML=`<g transform="translate(${(tx-122).toFixed(1)} ${(ty-248).toFixed(1)})">${tag.innerHTML}</g>`; }
  const [bagX,bagY]=PA(L-8,W-8,H+34), bagFloorY=PA(L-8,W-8,0)[1], bagScale=(bagFloorY-bagY)/(BAG.bot-BAG.top+38);
  const bagWidthScale=bagScale*1.45;
  $('#bagL').setAttribute('transform',`translate(${bagX-bagWidthScale*(BAG.cx-48)} ${bagY-bagScale*(BAG.top-38)}) scale(${bagWidthScale} ${bagScale})`);
  /* Keep the original broad mat shape beside the long side of the bed. */
  $('#matL').setAttribute('transform','translate(345,682) rotate(11) scale(.93) translate(-400,-690)');
}

const BAG=SH.bag;
const D_BAG=`M${BAG.cx-BAG.hw+4},${BAG.top+8} C${BAG.cx-BAG.hw-3},${BAG.top+40} ${BAG.cx-BAG.hw-1},${BAG.bot-34} ${BAG.cx-BAG.hw+6},${BAG.bot-12} C${BAG.cx-18},${BAG.bot+4} ${BAG.cx+18},${BAG.bot+4} ${BAG.cx+BAG.hw-6},${BAG.bot-12} C${BAG.cx+BAG.hw+1},${BAG.bot-34} ${BAG.cx+BAG.hw+3},${BAG.top+40} ${BAG.cx+BAG.hw-4},${BAG.top+8} C${BAG.cx+14},${BAG.top} ${BAG.cx-14},${BAG.top} ${BAG.cx-BAG.hw+4},${BAG.top+8} Z`;

function drawScene(){
  const defs=[], g=k=>find(k,S.pick[k]);
  const c=g('comforter'), p=g('backrest'), bl=g('blanket'), po=g('poster'), lb=g('laundry'), m=g('mat'),
        sh=picked('sheets')[0], sheetTop=picked('sheets')[1]||sh, pls=picked('plush'), fps=picked('funpillow'), sks=picked('sockbag');

  /* The mattress. Sheets colour it. A comfort pick makes it a little thicker and
     softer at the top, and lifts everything lying on it by the same amount.
     Abbie, 2026-09-10: "make the mattress look a drop more plush". The memory
     foam egg crate lifts most, the mattress pad least (plush, per product). */
  const lift = Math.min(22, pls.reduce((a,i)=>a+(i.plush||10),0)), my=392-lift, mh=70+lift;   // two picks stack, within reason
  let mo=`<rect x="144" y="${my}" width="574" height="${mh}" rx="${13+lift/2}" fill="${sh?sh.hex:'var(--mattress)'}"/>`;
  if(pls.length){
    defs.push(`<linearGradient id="plushG" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#fff" stop-opacity=".30"/><stop offset=".42" stop-color="#fff" stop-opacity="0"/>
      <stop offset="1" stop-color="#2A1A0C" stop-opacity=".10"/></linearGradient>`);
    mo+=`<rect x="144" y="${my}" width="574" height="${mh}" rx="${13+lift/2}" fill="url(#plushG)"/>`;
    mo+=`<path d="M160,${my+7} C 320,${my+1} 540,${my+1} 702,${my+7}" fill="none" stroke="rgba(255,255,255,.5)"
       stroke-width="${2+lift/5}" stroke-linecap="round"/>`;
  }
  [12,32,52].forEach(dy=>{ mo+=`<rect x="144" y="${my+lift+dy}" width="574" height="3"
     fill="${sh?'rgba(0,0,0,.16)':'var(--mattress-line)'}" opacity="${pls.length?.4:.55}"/>`; });
  if(!sh && onStep('sheets')) mo+=GHOST([`M144,${my} h574 v${mh} h-574 Z`],'Sheets',430,my+mh/2+7);
  if(!pls.length && onStep('plush'))  mo+=GHOST(['M152,392 C 300,370 560,370 710,392'],'Comfort',430,370);
  $('#mattL').innerHTML=mo;

  if(po){
    $('#postL').innerHTML=
      `<rect x="${POS.x-5}" y="${POS.y-5}" width="${POS.w+10}" height="${POS.h+10}" rx="2" fill="#F7F3EA"
         stroke="rgba(0,0,0,.16)" stroke-width="1.5"/>`+
      `<image href="${POSTER[po.k]}" x="${POS.x}" y="${POS.y}" width="${POS.w}" height="${POS.h}"
         preserveAspectRatio="xMidYMid slice"/>`+
      `<rect x="${POS.x}" y="${POS.y}" width="${POS.w}" height="${POS.h}" fill="none" stroke="rgba(0,0,0,.18)"/>`+
      `<rect x="${POS.x+POS.w/2-11}" y="${POS.y-11}" width="22" height="9" rx="1" fill="rgba(245,238,220,.82)"
         stroke="rgba(0,0,0,.12)" transform="rotate(-3 ${POS.x+POS.w/2} ${POS.y-7})"/>`;
  } else $('#postL').innerHTML = onStep('poster')
    ? GHOST([`M${POS.x},${POS.y} h${POS.w} v${POS.h} h-${POS.w} Z`],'Poster',POS.x+POS.w/2,POS.y+POS.h/2+7) : '';

  if(m){
    const f=fill(defs,m,CAT.mat);
    $('#matL').innerHTML=
      `<ellipse cx="400" cy="736" rx="162" ry="12" fill="var(--shadow)" opacity=".5"/>`+
      `<path d="${D_MAT}" fill="${f}"/><path d="${D_MAT}" fill="none" stroke="rgba(0,0,0,.22)" stroke-width="2.5"/>`+
      `<path d="${D_MAT}" fill="url(#lightG)" opacity=".3"/>`;
  } else $('#matL').innerHTML = onStep('mat') ? GHOST([D_MAT],'Mat',400,700) : '';

  if(c){
    const f=fill(defs,c,CAT.comforter);
    let o=`<path d="${D_COMF}" fill="${f}"/>`;
    o+=`<path d="M150,392 C 280,366 470,364 706,388 C 706,398 706,404 706,410 C 470,386 280,388 150,414 Z" fill="rgba(255,255,255,.17)"/>`;
    o+=`<path d="M152,438 C 288,414 470,412 706,436" fill="none" stroke="rgba(0,0,0,.12)" stroke-width="3.5"/>`;
    o+=`<path d="${D_COMF}" fill="url(#lightG)" opacity=".22"/>`;
    if(c.r){
      const back = c.rk ? fill(defs,{k:c.rk},CAT.comforter) : (REV[c.k]||'#B9C4C2');
      o+=`<path d="${D_CUFF}" fill="${back}"/>`;
      o+=`<path d="M150,390 C 244,368 344,370 424,386 L 421,400 C 342,384 242,382 151,404 Z" fill="rgba(255,255,255,.22)"/>`;
      o+=`<path d="M154,444 C 234,424 332,422 414,440" fill="none" stroke="rgba(0,0,0,.2)" stroke-width="4"/>`;
    }
    if(sh){   /* the top sheet, folded back over the comforter at the head (the second sheet pick, if there is one) */
      o+=`<path d="M150,390 C 244,368 344,370 424,386 L 422,400 C 342,384 244,382 151,404 Z" fill="${sheetTop.hex}"/>`;
      o+=`<path d="M151,404 C 244,382 342,384 422,400" fill="none" stroke="rgba(0,0,0,.2)" stroke-width="2.5"/>`;
    }
    o+=`<path d="${D_COMF}" fill="none" stroke="rgba(0,0,0,.2)" stroke-width="2.5" stroke-linejoin="round"/>`;
    $('#comfL').innerHTML=o;
  } else $('#comfL').innerHTML = onStep('comforter') ? GHOST([D_COMF],'Comforter',430,470) : '';

  if(bl){
    const f=fill(defs,bl,CAT.blanket);
    $('#thrL').innerHTML=
      `<path d="${SH.throw}" fill="${f}"/>`+
      `<path d="${SH.fold}" fill="${f}"/>`+
      `<path d="${SH.fold}" fill="rgba(0,0,0,.13)"/>`+
      `<path d="M512,392 C570,378 650,376 714,382 L712,414 C650,407 570,409 510,424" fill="none"
         stroke="rgba(0,0,0,.22)" stroke-width="2.5" stroke-linejoin="round"/>`+
      `<path d="${SH.throw}" fill="none" stroke="rgba(0,0,0,.22)" stroke-width="2.5" stroke-linejoin="round"/>`;
  } else $('#thrL').innerHTML = onStep('blanket') ? GHOST([SH.throw],'Throw',612,470) : '';

  /* The memory foam pillow, lying at the head of the bed behind the backrest. Abbie, 2026-09-16: "draw the
     pillow on the bed". Its case takes the sheet colour (the 4-piece sets include a pillowcase), else white. */
  const sleepPillow=pls.find(i=>/pillow/i.test(i.n));
  if(sleepPillow){
    const cs=sh?sh.hex:'#F8F6F1', PX=150, PY=354, PW=128, PH=50;
    const D_SP=`M${PX+10},${PY+6} C${PX+44},${PY-3} ${PX+PW-44},${PY-3} ${PX+PW-8},${PY+5} C${PX+PW+4},${PY+18} ${PX+PW+4},${PY+PH-16} ${PX+PW-8},${PY+PH-4} C${PX+PW-44},${PY+PH+4} ${PX+44},${PY+PH+4} ${PX+10},${PY+PH-4} C${PX-3},${PY+PH-16} ${PX-3},${PY+18} ${PX+10},${PY+6} Z`;
    defs.push(`<linearGradient id="spG" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#fff" stop-opacity=".35"/>
      <stop offset=".5" stop-color="#fff" stop-opacity="0"/><stop offset="1" stop-color="#2A1A0C" stop-opacity=".14"/></linearGradient>`);
    $('#sleepL').innerHTML=`<g transform="rotate(-4 ${PX+PW/2} ${PY+PH/2})">`+
      `<ellipse cx="${PX+PW/2}" cy="${PY+PH+2}" rx="${PW*.46}" ry="6" fill="rgba(0,0,0,.16)"/>`+
      `<path d="${D_SP}" fill="${cs}"/><path d="${D_SP}" fill="url(#spG)"/>`+
      `<path d="M${PX+22},${PY+PH/2+2} C${PX+50},${PY+PH/2-4} ${PX+PW-50},${PY+PH/2-4} ${PX+PW-22},${PY+PH/2+2}" fill="none" stroke="rgba(0,0,0,.08)" stroke-width="3" stroke-linecap="round"/>`+
      `<path d="${D_SP}" fill="none" stroke="rgba(0,0,0,.2)" stroke-width="2"/></g>`;
  } else $('#sleepL').innerHTML='';

  if(p){
    const f=fill(defs,p,CAT.backrest), ink='rgba(0,0,0,.24)';
    defs.push(`<clipPath id="pc"><path d="${SH.pill}"/></clipPath>`);
    defs.push(`<linearGradient id="ps" x1="0" y1="${SH.top}" x2="0" y2="${SH.bot}" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="#fff" stop-opacity=".25"/><stop offset=".30" stop-color="#fff" stop-opacity=".04"/>
      <stop offset=".55" stop-color="#382A22" stop-opacity="0"/><stop offset="1" stop-color="#382A22" stop-opacity=".23"/>
    </linearGradient>`);
    $('#pillL').innerHTML=
      `<g transform="rotate(-1.5 ${SH.cx} ${SH.bot})">`+
      `<ellipse cx="${SH.cx}" cy="${SH.bot}" rx="98" ry="10" fill="rgba(0,0,0,.18)"/>`+
      `<path d="M${SH.cx-11},${SH.top+4} L${SH.cx-11},${SH.top-15} L${SH.cx+11},${SH.top-15} L${SH.cx+11},${SH.top+4}"
         fill="none" stroke="${ink}" stroke-width="7" stroke-linejoin="round"/>`+
      `<path d="${SH.pill}" fill="${f}"/><path d="${SH.pill}" fill="url(#ps)"/>`+
      `<g clip-path="url(#pc)"><path d="M${SH.backL},${SH.shY-4} L${SH.backL},${SH.bot}
         M${SH.backR},${SH.shY-4} L${SH.backR},${SH.bot}" stroke="rgba(56,42,34,.26)" stroke-width="1.6"/></g>`+
      `<path d="${SH.pill}" fill="none" stroke="${ink}" stroke-width="2"/></g>`;
  } else $('#pillL').innerHTML = onStep('backrest') ? GHOST([SH.pill],'Backrest',SH.cx,SH.top+60) : '';

  /* Fun pillows in their own shape. Abbie, 2026-09-10: "I also want it to be in the
     shape of the pillow itself". Each is its product photo with the background cut
     away (assets/bunk-pillows.js), standing on the bed. Minis are drawn smaller. A
     pillow without a cutout falls back to its photo in a rounded outline. */
  if(fps.length){
    $('#funL').innerHTML=fps.map((it,i)=>{
      const spot=FUN_SPOTS[i%FUN_SPOTS.length], cut=it.cut, mini=/\bmini\b/i.test(it.n);
      const h=mini?56:84, w=cut?Math.min(150,h*cut.w/cut.h):h*1.2, x=spot.cx-w/2, y=spot.by-h;
      const art = cut
        ? `<image href="${cut.src}" x="${x}" y="${y}" width="${w}" height="${h}" preserveAspectRatio="xMidYMax meet"/>`
        : `<clipPath id="fpc${i}"><rect x="${x}" y="${y}" width="${w}" height="${h}" rx="16"/></clipPath>`+
          `<image href="${it.img}" x="${x}" y="${y}" width="${w}" height="${h}" preserveAspectRatio="xMidYMid slice" clip-path="url(#fpc${i})"/>`;
      return `<g transform="rotate(${spot.rot} ${spot.cx} ${spot.by})">`+
        `<ellipse cx="${spot.cx}" cy="${spot.by+1}" rx="${w*0.42}" ry="6" fill="rgba(0,0,0,.2)"/>${art}</g>`;
    }).join('');
  } else $('#funL').innerHTML = onStep('funpillow') ? GHOST([D_FUN],'Fun pillow',FUN.cx,FUN.cy+7) : '';

  if(lb){
    const f=fill(defs,lb,CAT.laundry);
    defs.push(`<pattern id="mesh" width="7" height="7" patternUnits="userSpaceOnUse">
      <path d="M0,0 L7,0 M0,0 L0,7" stroke="rgba(255,255,255,.34)" stroke-width="1.4"/></pattern>`);
    defs.push(`<clipPath id="bc"><path d="${D_BAG}"/></clipPath>`);
    $('#bagL').innerHTML=
      `<path d="M${BAG.cx-16},${BAG.top+8} C${BAG.cx-24},${BAG.top-16} ${BAG.cx-30},${BAG.top-30} ${BAG.cx-48},${BAG.top-38}"
         fill="none" stroke="#6B4A2C" stroke-width="5" stroke-linecap="round"/>`+
      `<path d="M${BAG.cx+16},${BAG.top+8} C${BAG.cx+6},${BAG.top-18} ${BAG.cx-26},${BAG.top-32} ${BAG.cx-48},${BAG.top-38}"
         fill="none" stroke="#7C5936" stroke-width="5" stroke-linecap="round"/>`+
      `<path d="${D_BAG}" fill="${f}"/>`+
      `<g clip-path="url(#bc)"><rect x="${BAG.cx-BAG.hw-4}" y="${BAG.top}" width="${BAG.hw*2+8}"
         height="${BAG.bot-BAG.top+8}" fill="url(#mesh)"/></g>`+
      `<path d="M${BAG.cx-BAG.hw+2},${BAG.top+16} C${BAG.cx-14},${BAG.top+8} ${BAG.cx+14},${BAG.top+8} ${BAG.cx+BAG.hw-2},${BAG.top+16}"
         fill="none" stroke="rgba(0,0,0,.26)" stroke-width="3.5"/>`+
      `<path d="${D_BAG}" fill="none" stroke="rgba(0,0,0,.24)" stroke-width="2.5" stroke-linejoin="round"/>`;
  } else $('#bagL').innerHTML = onStep('laundry') ? GHOST([D_BAG],'Laundry bag',BAG.cx,BAG.top-52) : '';

  /* Sock bags (Abbie, 2026-10-14): up to three small photo cards on the floor at the foot of the bed. */
  const skEl=$('#sockL');
  if(skEl){
    const SOCK_SPOTS=[{cx:802,by:742,rot:-5},{cx:852,by:744,rot:4},{cx:828,by:704,rot:-2}];
    skEl.innerHTML = sks.length ? sks.slice(0,3).map((it,i)=>{
      const sp=SOCK_SPOTS[i%3], c=it.cut, h=c?78:70, w=c?Math.min(70,h*c.w/c.h):62, x=sp.cx-w/2, y=sp.by-h;
      const art = c
        ? `<image href="${c.src}" x="${x}" y="${y}" width="${w}" height="${h}" preserveAspectRatio="xMidYMax meet"/>`
        : `<clipPath id="skc${i}"><rect x="${x}" y="${y}" width="${w}" height="${h}" rx="12"/></clipPath>`+
          `<image href="${it.img}" x="${x}" y="${y}" width="${w}" height="${h}" preserveAspectRatio="xMidYMid slice" clip-path="url(#skc${i})"/>`+
          `<rect x="${x}" y="${y}" width="${w}" height="${h}" rx="12" fill="none" stroke="rgba(0,0,0,.25)" stroke-width="2"/>`;
      return `<g transform="rotate(${sp.rot} ${sp.cx} ${sp.by})"><ellipse cx="${sp.cx}" cy="${sp.by+1}" rx="${w*0.46}" ry="5" fill="rgba(0,0,0,.2)"/>${art}</g>`;
    }).join('') : (onStep('sockbag') ? GHOST(['M772,700 h60 v42 h-60 z'],'Sock bag',802,690) : '');
  }

  if(S.name.trim()){
    const t=S.name.trim().toUpperCase().replace(/[<&>]/g,''),w=Math.max(96,t.length*17+42);
    $('#tagL').innerHTML=
      `<g transform="translate(${122+w/2},312)"><path d="M0,-64 L0,-30" stroke="var(--frame-dark)" stroke-width="3"/>`+
      `<rect x="${-w/2}" y="-30" width="${w}" height="46" rx="9" fill="var(--frame-light)" stroke="var(--frame-dark)" stroke-width="3"/>`+
      `<circle cy="-22" r="3.6" fill="var(--frame-dark)"/>`+
      `<text y="4" text-anchor="middle" fill="#2B1B0B" font-family="Bricolage Grotesque, sans-serif"
        font-size="23" font-weight="800" letter-spacing=".1em">${t}</text></g>`;
  } else $('#tagL').innerHTML='';
  ['comfL','thrL','sleepL','pillL','funL'].forEach(id=>{      // bedding rides up on a plusher mattress
    const el=$('#'+id); if(!el) return;
    lift ? el.setAttribute('transform',`translate(0,${-lift})`) : el.removeAttribute('transform');
  });
  if(ANGLED) drawAngled(defs,{c,p,bl,lb,sh,sheetTop,pls,fps,lift});
  else { const st=$('#bedStraight'); if(st) st.style.display=''; $('#matL').removeAttribute('transform'); $('#bagL').removeAttribute('transform'); $('#postL').removeAttribute('transform'); }
  if(ANGLED){
    let bedGroup=$('#bedEnlarged');
    if(!bedGroup){ bedGroup=document.createElementNS('http://www.w3.org/2000/svg','g'); bedGroup.id='bedEnlarged'; $('#scene').appendChild(bedGroup); }
    ['mattL','comfL','thrL','pillL','sleepL','funL','bagL','tagL'].forEach(id=>bedGroup.appendChild($('#'+id)));
    bedGroup.setAttribute('transform','matrix(1.15 0 0 1.15 -100 -80)');
  }
  $('#dyn').innerHTML=defs.join('');
}

const SRC=it=>it.art?POSTER[it.k]:TILE[it.k];
const swStyle=it=>
  it.hex ? `background:${it.hex};` :
  it.cut ? `background-image:url(${it.cut.src});background-size:contain;background-repeat:no-repeat;background-color:#fff;` :
  it.img ? `background-image:url(${it.img});background-size:cover;background-color:#fff;` :
  `background-image:url(${SRC(it)});`+
  (it.art||it.stretch||(TRATIO[it.k]&&TRATIO[it.k]!==1)?'background-size:cover;':'');
function drawSteps(){
  const cols=(ORDER.length>9 && window.innerWidth>=700)?5:3, rows=Math.ceil(ORDER.length/cols);
  $('#steps').style.gridTemplateColumns='repeat('+cols+',1fr)';
  $('#steps').innerHTML=ORDER.map((k,i)=>{
    const ps=picked(k), it=ps[0];
    const edge=((i+1)%cols===0?' rowend':'')+(Math.floor(i/cols)===rows-1?' lastrow':'');
    return `<button class="step${it?' done':''}${edge}" role="tab" aria-current="${i===S.step}" data-step="${i}">
      <span class="num">STEP ${i+1}</span><span class="nm">${CAT[k].label}</span>
      <span class="st">${it?'✓ '+(ps.length>1?ps.length+' picked':it.n.split(' ').slice(0,2).join(' ')):CAT[k].hint}</span></button>`}).join('');
  $('#steps').querySelectorAll('.step').forEach(b=>b.onclick=()=>{S.step=+b.dataset.step;render()});
}
function drawGrid(){
  const k=ORDER[S.step],c=CAT[k],opts=optionsFor(k).slice().sort((a,b)=>(a.so?1:0)-(b.so?1:0)),mx=maxOf(k),on=id=>picks(k).includes(id);
  $('#optTitle').textContent=c.plural;
  const gone=opts.filter(i=>i.so).length;
  $('#optCount').textContent=(opts.length-gone)+' to choose from'+(gone?` · ${gone} sold out`:'')+(mx>1?` · pick up to ${mx}`:'');
  $('#grid').innerHTML=opts.map(i=>
    `<button class="opt${i.so?' soldout':''}" role="option" aria-pressed="${on(i.id)}" aria-selected="${on(i.id)}" aria-disabled="${!!i.so}" data-id="${i.id}">
      <span class="sw" style="${swStyle(i)}">
        ${i.r?`<span class="back" style="${i.rk
            ? `background-image:url(${TILE[i.rk]});background-size:64px`
            : `background:${REV[i.k]}`}"></span><span class="diag"></span>`:''}
        <span class="tick">✓</span>${i.r?'<span class="rev">Reversible</span>':''}
        ${i.so?'<span class="sobadge">Sold out</span>':''}${i.sale&&!i.so&&dealSettings()?'<span class="salebadge">Sale</span>':''}${i.pers&&!i.so?'<span class="persbadge">Add a name</span>':''}${i.pz&&!i.so?'<span class="persbadge">Name it</span>':''}
        ${i.ph?'<span class="phbadge" title="Artwork not supplied yet">art tbc</span>':''}
        ${i.q?'<span class="phbadge" title="Product name is my guess — please correct">name?</span>':''}</span>
      <span class="meta"><span class="nm">${i.n}</span><span class="pr">$${i.p}</span></span></button>`).join('');
  $('#grid').querySelectorAll('.opt').forEach(b=>b.onclick=()=>{
    const id=b.dataset.id;
    if(b.classList.contains('soldout')){ toast('Sorry — that one is sold out right now.'); return; }
    if(mx>1){                                  // comfort and fun pillows: tick several
      const cur=picks(k);
      if(cur.includes(id)) S.pick[k]=cur.filter(x=>x!==id);
      else if(cur.length>=mx){ toast(`You can pick up to ${mx} here — untick one to swap.`); return; }
      else S.pick[k]=[...cur,id];
      render(); return;
    }
    S.pick[k] = S.pick[k]===id ? null : id;
    const now=find(k,S.pick[k]);
    if(!now || !now.pers) S.pers[k]={a:'',b:''};
    render()});
  drawPers(); drawSuggest(); drawNav();
}
function drawNav(){
  const k=ORDER[S.step], has=picks(k).length>0, last=S.step===ORDER.length-1;
  const nextLabel = last ? 'Review your bunk'
        : `${has?'Next':'Skip'} · ${CAT[ORDER[S.step+1]].label}`;
  $('#navBox').innerHTML=
    `<div class="stepnav">
       <button class="mini" id="prevStep" ${S.step===0?'disabled':''}>← Back</button>
       <span class="navhint">${has
          ? 'Try as many as you like — this one\u2019s in.'
          : 'Click any swatch to try it on the bunk.'}</span>
       <button class="nextbtn${has||last?' on':''}" id="nextStep">${nextLabel} →</button>
     </div>`;
  $('#prevStep').onclick=()=>{ if(S.step>0){S.step--;render()} };
  $('#nextStep').onclick=()=>{
    if(last){ document.querySelector('.sum').scrollIntoView({behavior:'smooth',block:'center'}); }
    else { S.step++; render(); }
  };
}
function drawSuggest(){
  const k=ORDER[S.step], it=picked(k)[0];
  const box=$('#sugBox'); if(!it||it.art){box.innerHTML='';return}
  const hits=[], seen=new Set();
  const push=(o,m,why)=>{ const key=o+m.id; if(seen.has(key))return; seen.add(key); hits.push({cat:o,it:m,why}); };
  ORDER.forEach(o=>{ if(o===k||picks(o).length||CAT[o].art) return;
    const m=optionsFor(o).find(x=>x.k===it.k&&!x.so); if(m) push(o,m,'same print'); });
  (PAIRS[it.k]||[]).forEach(pk=>ORDER.forEach(o=>{ if(o===k||picks(o).length||CAT[o].art) return;
    const m=optionsFor(o).find(x=>x.k===pk&&!x.so); if(m) push(o,m,'pairs well'); }));
  if(!hits.length){box.innerHTML='';return}
  box.innerHTML=`<div class="sug"><div class="sh">Goes great with</div><div class="srow">`+
    hits.slice(0,3).map(({cat,it:m,why})=>
      `<button class="sug-chip" data-cat="${cat}" data-id="${m.id}">
         <span class="sc-sw" style="${swStyle(m)}"></span>
         <span class="sc-t"><span class="sc-n">${m.n}</span>
           <span class="sc-p">${CAT[cat].label} · $${m.p} · ${why}</span></span>
         <span class="sc-add">Add</span></button>`).join('')+`</div></div>`;
  box.querySelectorAll('.sug-chip').forEach(b=>b.onclick=()=>{
    const cat=b.dataset.cat;
    S.pick[cat]=maxOf(cat)>1?[...picks(cat),b.dataset.id].slice(0,maxOf(cat)):b.dataset.id;
    render(); toast('Added — matches your '+CAT[k].label.toLowerCase()+'.')});
}
function drawPers(){
  const k=ORDER[S.step], it=picked(k)[0], c=CAT[k], box=$('#persBox');
  if(PZ_STORE) box.querySelectorAll('[data-bunk-pz]').forEach(n=>PZ_STORE.appendChild(n));   // keep what was filled in
  const own=picked(k).filter(i=>i.pz);
  if(own.length){
    box.innerHTML=own.map(i=>`<div class="pzbox">${own.length>1?`<p class="pzname">${i.n}</p>`:''}</div>`).join('');
    const slots=box.querySelectorAll('.pzbox');
    own.forEach((i,n)=>{ slots[n].appendChild(i.pz);
      if(window.BBDP) BBDP.fill(i.pz,false);
      if(window.BBP) i.pz.querySelectorAll('[data-bbp]').forEach(r=>BBP.update(r)); });
    return;
  }
  if(!it||!it.pers){box.innerHTML='';return}
  const two=!!c.pers2, v=S.pers[k];
  $('#persBox').innerHTML=
    `<div class="pers"><div class="ph"><b>Make it ${S.side==='boys'?'his':'hers'}</b><span class="tagpill">Personalised</span></div>
     <p>${it.n} is printed with your camper's name${two?' and camp name':''}. ${two?'Both are':'It is'} needed
        before it can go in the cart — it won't change the picture, but it travels with the order.</p>
     <input id="persA" type="text" maxlength="18" autocomplete="off"
       placeholder="Camper's name" value="${v.a.replace(/"/g,'&quot;')}">`+
    (two?`<input id="persB" type="text" maxlength="18" autocomplete="off"
       placeholder="${c.pers2}" value="${v.b.replace(/"/g,'&quot;')}">`:'')+`</div>`;
  $('#persA').oninput=e=>{S.pers[k].a=e.target.value.slice(0,18);drawSummary();save()};
  if(two)$('#persB').oninput=e=>{S.pers[k].b=e.target.value.slice(0,18);drawSummary();save()};
}
function drawSummary(){
  const chosen=ORDER.flatMap(k=>{ const ps=picked(k); return ps.length?ps.map(i=>({k,i})):[{k,i:null}]; });
  $('#lines').innerHTML=chosen.map(({k,i})=>
    `<div class="line"><span class="chip${i?'':' empty'}" ${i?`style="${swStyle(i)}"`:''}></span>
      <span class="txt"><span class="k">${CAT[k].label}</span>
        <span class="v${i?'':' none'}">${i?i.n:'Not picked yet'}${
          i&&i.pers&&(S.pers[k].a||S.pers[k].b)
            ? ` <small>· ${[S.pers[k].a,S.pers[k].b].filter(Boolean).join(' · ').toUpperCase()}</small>`
            : i&&pzNote(i) ? ` <small>· ${pzNote(i).replace(/[<&>]/g,'')}</small>` : ''}</span></span>
      ${i?`<span class="amt">$${priceOf(i)}</span><button class="x" data-k="${k}" data-id="${i.id}" aria-label="Remove ${i.n}">×</button>`:''}
    </div>`).join('');
  $('#lines').querySelectorAll('.x').forEach(b=>b.onclick=()=>{
    const k=b.dataset.k;
    if(maxOf(k)>1) S.pick[k]=picks(k).filter(id=>id!==b.dataset.id);
    else { S.pick[k]=null; S.pers[k]={a:'',b:''}; }
    render()});
  const items=chosen.filter(x=>x.i),total=Math.round(items.reduce((s,x)=>s+priceOf(x.i),0)*100)/100,n=ORDER.length,
        done=ORDER.filter(k=>picks(k).length).length,
        need=items.find(({k,i})=>pzMissing(i)||i.pers&&(!S.pers[k].a.trim()||(CAT[k].pers2&&!S.pers[k].b.trim())));
  $('#total').textContent='$'+total;
  $('#cta').disabled=!items.length;
  $('#cta').textContent=need ? (need.i.pz ? `Finish the name for your ${CAT[need.k].label.toLowerCase()}`
      : `Add the name${CAT[need.k].pers2?' and camp name':''} for your ${CAT[need.k].label.toLowerCase()}`)
    : items.length?`Add ${items.length} item${items.length>1?'s':''} to cart · $${total}`:'Add bunk to cart';
  $('#ship').textContent=!items.length?'Nothing picked yet.'
    :done<n?`${n-done} more to finish the bunk.`:`Bunk complete — all ${n} picked.`;
  drawDeal(items.filter(x=>!x.i.so&&x.i.sale).length);
  $('#cap').textContent=!items.length?'An empty bunk, waiting for a camper.'
    :done<n?'Coming together…'
    :(S.name.trim()?S.name.trim()+"'s bunk is ready.":'This bunk is ready for camp.');
}
/* Bunk deal. Abbie, 2026-09-22: start with a plain automatic discount, 20% off 4+ items from "The Bunk Edit 20% off
   Sale" collection (products tagged "bunk edit"), from anywhere on the site. Pre-sale sheets and comforters aren't
   tagged. The countdown counts only picks carrying that tag (`sale`, set in bunk-product-json) so it never promises
   a discount checkout won't give. Off unless the section's "Show the bunk deal countdown" is ticked. */
// Read when drawn, not at load: the first render can run before this part of the file has.
function dealSettings(){ const d=(document.querySelector('[data-bunk-builder]')||{}).dataset||{};
  const min=parseInt(d.bunkDealMin,10), pct=parseInt(d.bunkDealPct,10);
  return min>0&&pct>0?{min,pct}:null; }
function drawDeal(count){
  const el=$('#deal'), DEAL=dealSettings(); if(!el) return;
  if(!DEAL){ el.hidden=true; return; }
  const left=DEAL.min-count;
  el.hidden=false; el.classList.toggle('on',left<=0);
  el.textContent=left>0
    ? (count?`${count} sale item${count>1?'s':''} picked. Add ${left} more to get ${DEAL.pct}% off them.`
            :`The Bunk Edit Sale: pick ${DEAL.min} or more items marked Sale and get ${DEAL.pct}% off them.`)
    : `You unlocked ${DEAL.pct}% off your sale items! It comes off at checkout.`;
}
function render(){drawSteps();drawGrid();drawSummary();drawScene();save()}

let tT;
const toast=m=>{const t=$('#toast');t.textContent=m;t.classList.add('on');
  clearTimeout(tT);tT=setTimeout(()=>t.classList.remove('on'),2100)};
$('#persBox').addEventListener('bbp:change',()=>drawSummary());
$('#who').oninput=e=>{S.name=e.target.value.slice(0,12);drawScene();drawSummary();save()};
/* Surprise Me keeps a bunk on one side. Abbie, 2026-09-10: "with surprise me - we need to keep it
   for girls together and boys together". Comforters and fun pillows carry their own side. Other prints
   take the side of the comforter in the same print, or are named here. Posters go by their artwork
   and sheets by colour. Anything unnamed counts as both. */
const PRINT_SIDE={terez:'girls',cosmic:'girls',leopard:'girls',girlcollage:'girls',sparklesdenim:'girls',grunge:'both'};
(CAT.comforter?CAT.comforter.items:[]).forEach(i=>{ if(i.side && !(i.k in PRINT_SIDE)) PRINT_SIDE[i.k]=i.side; });
function sideOf(k,it){
  if(it.side) return it.side;
  if(k==='poster') return /ballpark|g-o-a-t|sports/.test(it.k)?'boys':/grunge|mash-up/.test(it.k)?'both':'girls';
  if(k==='sheets') return /pink|purple|lavender/i.test(it.n)?'girls':/royal blue|navy|black|hunter green/i.test(it.n)?'boys':'both';
  return PRINT_SIDE[it.k]||'both';
}
const surprise=()=>{
  const any=a=>a[Math.floor(Math.random()*a.length)];
  const side=S.side;                                                    // the girl/boy question at the top
  ORDER.forEach(k=>{
    const all=optionsFor(k).filter(i=>!i.so), fit=all.filter(i=>{ const s=sideOf(k,i); return s===side||s==='both'; });
    if(!all.length){ S.pick[k]=maxOf(k)>1?[]:null; return; }
    const id=any(fit.length?fit:all).id; S.pick[k]=maxOf(k)>1?[id]:id;
  });
  S.step=ORDER.length-1;render();toast('Here you go — one random bunk.')};
$('#rand').onclick=surprise; $('#rand2').onclick=surprise;
/* Tap anything on the bunk to change it. Abbie, 2026-09-11: "if you click on the image of the
   boyfriend pillow, it takes you back to the boyfriend pillow options to change. same with mat,
   laundry bag, comforter, etc." Works on the straight and the angled bed: every piece is drawn
   into its own layer, so the layer that was tapped says which step to open. */
const LAYER_SLOT={comfL:'comforter',mattL:'sheets',sleepL:'plush',pillL:'backrest',funL:'funpillow',thrL:'blanket',
  postL:'poster',bagL:'laundry',sockL:'sockbag',matL:'mat'};
$('#scene').addEventListener('click',e=>{
  let el=e.target;
  while(el && el.id!=='scene' && !LAYER_SLOT[el.id] && el.id!=='tagL') el=el.parentNode;
  if(!el || el.id==='scene') return;
  if(el.id==='tagL'){ const who=$('#who'); if(who){ who.scrollIntoView({behavior:'smooth',block:'center'}); who.focus(); } return; }
  const k=LAYER_SLOT[el.id]; if(!ORDER.includes(k)) return;
  S.step=ORDER.indexOf(k); render();
  // on a phone the options sit under the picture, so bring them into view
  if(window.matchMedia('(max-width: 900px)').matches) $('#grid').scrollIntoView({behavior:'smooth',block:'start'});
});
$('#reset').onclick=()=>{pzReset();ORDER.forEach(k=>{S.pick[k]=maxOf(k)>1?[]:null;S.pers[k]={a:'',b:''}});S.name='';S.step=0;$('#who').value='';
  render();toast('Back to an empty bunk.')};
$('#copy').onclick=async()=>{save();
  try{await navigator.clipboard.writeText(location.href);toast('Link copied — paste it anywhere to share this bunk.')}
  catch(e){toast('Copy the address bar to share this bunk.')}};
$('#cta').onclick=async()=>{
  const btn=$('#cta'), lines=ORDER.flatMap(k=>picked(k).filter(i=>!i.so).map(i=>({k,i})));
  if(!lines.length) return;
  const need=lines.find(({k,i})=>pzMissing(i)||i.pers&&(!S.pers[k].a.trim()||(CAT[k].pers2&&!S.pers[k].b.trim())));
  if(need && need.i.pz){  // its own fields: mark what's missing in red and jump to it, like the product page
    S.step=ORDER.indexOf(need.k); render();
    const miss=window.BBP?BBP.check(need.i.pz):[];
    if(miss[0]&&miss[0].input){ if(window.BBDP) BBDP.goTo(miss[0].input); else { miss[0].input.scrollIntoView({behavior:'smooth',block:'center'}); miss[0].input.focus(); } }
    toast('Finish the name for your '+CAT[need.k].label.toLowerCase()+' first.');
    return;
  }
  if(need){               // a personalised item cannot be made without its names
    S.step=ORDER.indexOf(need.k); render();
    const f=$('#persA'); if(f){ f.scrollIntoView({behavior:'smooth',block:'center'}); f.focus(); }
    toast(CAT[need.k].pers2?'Add the camper’s name and camp name first.':'Add the camper’s name first.');
    return;
  }
  btn.disabled=true; const was=btn.textContent; btn.textContent='Adding…';
  /* One group per product: the product line plus any extra-charge lines for its name (sent together). */
  const groups=lines.map(({k,i},n)=>{
    if(i.pz && window.BBP){  // BBP numbers a group by the clock, so two in one click would share it: make each its own
      // _bunk_builder goes on the product line only (cartLines merges it there), not on its extra-charge lines
      const g=BBP.cartLines(i.pz,{id:i.vid,quantity:1,properties:{_bunk_builder:'yes'}}), own=String(Date.now()+n);
      g.forEach(l=>{ const pr=l.properties||{};
        if(pr._gpo_product_group) pr._gpo_product_group=own;
        if(pr._gpo_parent_product_group) pr._gpo_parent_product_group=own; });
      return g;
    }
    const v=S.pers[k], props={};
    if(i.pers && v.a) props[CAT[k].pers2?"Camper name":"Name"]=v.a.trim().toUpperCase();
    if(i.pers && v.b && CAT[k].pers2) props[CAT[k].pers2]=v.b.trim().toUpperCase();
    props._bunk_builder='yes';   // counted by the bunk deal discount; hidden (underscore) in cart and checkout
    const line={id:i.vid,quantity:1};
    if(Object.keys(props).length) line.properties=props;
    return [line];
  });
  const items=groups.flat();
  try{
    const add=body=>fetch('/cart/add.js',{method:'POST',
      headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
    const r=await add({items}), missed=[]; let added=lines.length;
    if(r.status===422){          // one line that has just sold out stops the whole add: add the rest one by one
      added=0;
      for(const [n,g] of groups.entries()){ const one=await add({items:g}); if(one.ok) added++; else missed.push(lines[n].i); }
      missed.forEach(i=>i.so=true);
    } else if(!r.ok){
      let msg='Could not add to cart'; try{ msg=(await r.json()).description||msg; }catch(err){}
      throw new Error(msg);
    }
    if(!added) throw new Error('Sorry — '+(missed.length>1?'those are':'that is')+' sold out right now.');
    if(S.name.trim()){          // carried once, on the order, not repeated on every line
      await fetch('/cart/update.js',{method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({attributes:{'Bunk tag':S.name.trim().toUpperCase()}})}).catch(()=>{});
    }
    /* Stay on the page. Abbie: "i 100% do not want anyone being moved to the cart."
       Update the header count and let the theme refresh its cart drawer, as after its own add. */
    const cart=await fetch('/cart.js').then(x=>x.json()).catch(()=>null);
    if(cart) document.querySelectorAll('.cart-link__count').forEach(el=>{const n=window.bbdCountOf?bbdCountOf(cart):cart.item_count;el.textContent=n>0?n:''});
    document.dispatchEvent(new CustomEvent('on:cart:change',{bubbles:true}));
    btn.disabled=false; btn.textContent=was;
    if(missed.length){ pruneSoldOut(); render(); }
    toast(missed.length
      ? `Added ${added} to your bag. Sold out right now: ${missed.map(i=>i.n).join(', ')}.`
      : `Added ${added} item${added>1?'s':''} to your bag.`);
  }catch(e){
    btn.disabled=false; btn.textContent=was;
    toast(e.message||'Something went wrong — please try again.');
  }
};

/* The girl/boy question. Switching keeps whatever is on both lists (sheets, some fun pillows) and takes off the rest. */
function setSide(side,quiet){
  if(side!=='girls'&&side!=='boys'||side===S.side){ applySide(); return; }
  S.side=side; applySide();
  const gone=pruneSide();
  const k=ORDER[S.step]; if(k&&!picks(k).length&&!quiet) S.step=0;
  render();
  if(!quiet) toast(gone ? `Building for a ${side==='boys'?'boy':'girl'} — took off ${gone} item${gone>1?'s':''} from the other side.`
                        : `Building for a ${side==='boys'?'boy':'girl'}.`);
}
document.querySelectorAll('[data-bunk-side]').forEach(b=>b.addEventListener('click',()=>setSide(b.dataset.bunkSide)));
/* The site's Girls/Boys switch: follow it while nothing has been picked yet. */
new MutationObserver(()=>{
  const aud=document.documentElement.dataset.bbdAudience;
  if((aud==='girls'||aud==='boys') && !ORDER.some(k=>picks(k).length)) setSide(aud,true);
}).observe(document.documentElement,{attributes:true,attributeFilter:['data-bbd-audience']});

/* Share and save (Abbie, 2026-09-16: "can the whole setup they made be shared to emailed to them? or in favorites?").
   A bunk is its link, which names every product, so emailing or saving it keeps the whole setup. */
const bunkLines=()=>ORDER.flatMap(k=>picked(k).map(i=>({k,i})));
const bunkUrl=()=>location.origin+location.pathname+'#'+bunkQuery();
const bunkTitle=()=>S.name.trim() ? `${S.name.trim()}'s bunk` : `My ${S.side==='boys'?'boy':'girl'}'s bunk`;
$('#email').onclick=()=>{
  const lines=bunkLines(); if(!lines.length){ toast('Pick something first, then email your bunk.'); return; }
  const total=Math.round(lines.reduce((s,x)=>s+priceOf(x.i),0)*100)/100;
  const body=`Here's the bunk I built at Bee Bee Designs:\n\n`+
    lines.map(({k,i})=>`• ${CAT[k].label}: ${i.n} — $${priceOf(i)}`).join('\n')+
    `\n\nTotal: $${total}\n\nOpen it and add everything to the cart:\n${bunkUrl()}\n`;
  location.href='mailto:?subject='+encodeURIComponent(`${bunkTitle()} — Build My Bunk™`)+'&body='+encodeURIComponent(body);
};
const SAVED_BUNKS='bbd-saved-bunks';
const readBunks=()=>{ try{ const l=JSON.parse(localStorage.getItem(SAVED_BUNKS)||'[]'); return Array.isArray(l)?l:[]; }catch(e){ return []; } };
$('#fav').onclick=()=>{
  const lines=bunkLines(); if(!lines.length){ toast('Pick something first, then save your bunk.'); return; }
  const q=bunkQuery(), list=readBunks();
  if(list.some(b=>b.q===q)){ toast('This bunk is already in your favorites.'); return; }
  const c=picked('comforter')[0];
  list.push({q, url:location.pathname+'#'+q, title:bunkTitle(), side:S.side, at:Date.now(),
    total:Math.round(lines.reduce((s,x)=>s+priceOf(x.i),0)*100)/100,
    items:lines.map(({k,i})=>CAT[k].label+': '+i.n), img:c&&c.h?c.h:''});
  try{ localStorage.setItem(SAVED_BUNKS,JSON.stringify(list.slice(-20))); }
  catch(e){ toast('Could not save on this device — try Email my bunk instead.'); return; }
  if(window.__bbdFav) window.__bbdFav.paintAll();
  toast('Saved to your favorites ♥ — find it under Saved.');
};

/* "Surprise Me" in the header's Build My Bunk dropdown links here with #surprise. */
const wantsSurprise = location.hash === '#surprise';
if (wantsSurprise) { try { history.replaceState(null, '', location.pathname); } catch (e) {} }
load(); pruneSide(); applySide(); const soldGone=pruneSoldOut(); $('#who').value=S.name;
S.step=ORDER.findIndex(k=>!picks(k).length); if(S.step<0)S.step=ORDER.length-1;
render();
if (soldGone && !wantsSurprise) toast(`${soldGone} item${soldGone>1?'s have':' has'} sold out since, so we took ${soldGone>1?'them':'it'} off your bunk.`);
if (wantsSurprise) surprise();
